<template>
    <div class="box-container">
        <div class="box-container-header">
            <h3 class="box-title">{{ $t('POLICY.LABEL.APPLIED_RULES') }}<!--적용된 규칙--> <span
                class="icon-count">{{ ruleList.length }}</span></h3>
            <!-- 사용자 정의 Policy 일 때만 규칙 추가 버튼 제공 -->
            <span class="seperate" v-if="isEditable && menuAuth === constants.AUTH_TYPE.EDIT">
                <button type="button" class="buttons" data-size="s"
                        data-icon="add"
                        data-trigger="add-rule"
                        @click="callOpenPopup(null, constants.FORM_TYPE.NEW)">
                    {{ $t('POLICY.BUTTON.ADD_RULE') }}<!--규칙 추가-->
                </button>
                <button type="button" class="buttons" data-size="s"
                        data-icon="add"
                        @click="callImportRule">
                    {{ $t('POLICY.BUTTON.IMPORT_RULE') }}<!--규칙 추가-->
                </button>
            </span>
        </div>
        <fieldset class="tbl-filters">
            <legend>table filters</legend>
            <div class="seperate">
                <select-box-multi
                    select-id="select_ctg"
                    select-class="type-checkbox"
                    place-holder="FILTER.SELECT_CATEGORY"
                    :select-box-options="ctgLabelFilterData"
                    @onSelectChange="callSetSearchKey('searchCtg',$event.value)"></select-box-multi>
                <select-box-multi
                    select-id="select_prod"
                    select-class="type-checkbox"
                    place-holder="FILTER.SELECT_PRODUCT"
                    :select-box-options="prodFilterData"
                    @onSelectChange="callSetSearchKey('searchProd',$event.value)"></select-box-multi>
            </div>
            <div class="search-box">
                <label>
                    <input type="search" size="35"
                           :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH')" ref="searchTxt"
                           @keyup="callSetSearchKey('searchTxt', $event.target.value)"
                    >
                </label>
                <button v-show="this.$refs.searchTxt !== undefined && this.$refs.searchTxt.value !== ''" class="buttons-icon" 
                    data-icon="clear" data-size="s" data-type="ghost" type="button" 
                    v-on:click="clearSearchTxt(); callSetSearchKey('searchTxt', '')">Reset
                </button>
                <button type="button" class="btn-search">Search</button>
            </div>
        </fieldset>

        <div v-if="isEditable && menuAuth === constants.AUTH_TYPE.EDIT" class="tbl-actions">
            <button type="button" class="buttons" data-type="line" data-size="s" data-icon="delete"
                    :disabled="checkList.length === 0" v-on:click="callDeleteRule(checkList)">
                {{ $t('POLICY.BUTTON.DELETE_RULE') }}
            </button>
        </div>

        <table class="tbl-default" data-linkable-row>
            <caption></caption>
            <colgroup>
                <col v-if="isEditable && menuAuth === constants.AUTH_TYPE.EDIT" style="width: 34px;">
                <col ref="columnRuleName">
                <col style="width: 347px;">
                <col style="width: 140px;">
                <col v-if="menuAuth === constants.AUTH_TYPE.EDIT" style="width: 125px;">
            </colgroup>
            <thead>
            <tr>
                <th v-if="isEditable && menuAuth === constants.AUTH_TYPE.EDIT" scope="col">
                    <input type="checkbox" id="select-all" name="select-all" class="checkbox txt-none"
                           v-model="selectCheckAll">
                    <label for="select-all">{{ $t('LABEL.SELECT') }}</label>
                </th>
                <th scope="col">
                    <button type="button" class="buttons-tbl-header"
                            v-bind:data-type="sortColumn !== 'titl' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                            v-on:click="callSetSortColumn('titl')">{{ $t('POLICY.RULE.TITLE') }}<!--규칙 이름--></button>
                </th>
                <th scope="col" style="width: 10%;" data-hide-by-side>
                    <button type="button" class="buttons-tbl-header"
                            v-bind:data-type="sortColumn !== 'prodNm' ? 'sort' : sortOrder === 'asc' ? 'sort-asce' : 'sort-desc'"
                            v-on:click="callSetSortColumn('prodNm')">{{ $t('LABEL.PRODUCT') }}<!--프로덕트--></button>
                </th>
                <th scope="col" data-hide-by-side>
                    <button type="button" class="buttons-tbl-header" data-type="filter"
                            data-tooltip-content="#tooltip-svrty-filter">{{ $t('LABEL.SEVERITY') }}<!--심각도--></button>
                    <div class="tooltip_templates">
                        <div id="tooltip-svrty-filter">
                            <ul class="list-filter">
                                <li v-for="(stat, index) of constants.SVRTY_FILTER" :key="index">
                                    <input type="checkbox" :id="stat.key" name="filter-type" class="checkbox" :value="stat.key" v-model="searchSvrty">
                                    <label :for="stat.key">{{ $t(stat.val) }}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </th>
                <!-- 관리 항목. 사용자 정의 Policy 일 때만 제공 -->
                <th scope="col" v-if="isEditable && menuAuth === constants.AUTH_TYPE.EDIT" data-hide-by-side>
                    {{ $t('LABEL.OPTIONS') }}<!--옵션-->
                </th>
            </tr>
            </thead>
            <tbody v-show="loadingRuleList">
                <tr><td><div-loading :full="true"></div-loading></td></tr>
            </tbody>
            <tbody>
            <tr v-for="(rule, indexRule) of getRulesFilter" 
                :key="rule.ruleId"
                v-bind:class="{'selected' : curRule != null && rule.ruleId === curRule.ruleId}"
                style="cursor:pointer">
                <td v-if="isEditable && menuAuth === constants.AUTH_TYPE.EDIT" class="txt-c rule-select">
                    <input type="checkbox" :id="rule.ruleId" v-model="checkList" class="checkbox txt-none"
                           :value="rule">
                    <label :for="rule.ruleId">{{ $t('LABEL.SELECT') }}</label>
                </td>
                <td v-on:click="openRuleDetail(rule, $event)" class="rule-title">
                    <div v-if="doneLoopArray(indexRule)">
                        <span :key="titlRender"
                            :title="getRuleTitle(rule)"
                            class="mr-2"
                        >
                            {{ getRuleTitle(rule) }}
                        </span>
                        <span>
                            <span v-bind="{'indexRule' : indexRule}">
                                <span class="icon-tag mx-1" data-type="category-label" v-for="(ctg, index) of rule.ctgLabel"
                                        :key="index">{{ getCategoryLabel(ctg) }}</span>
                            </span>
                        </span>
                        
                    </div>
                </td>

                <td v-on:click="openRuleDetail(rule, $event)" data-hide-by-side class="rule-product">
                    <RuleProducts
                        :ruleId="rule.ruleId"
                        :cndVal="rule.cndVal"
                        :autoExeYn="rule.autoExeYn"
                        :templateList="templateList"
                    />
                </td>
                <td v-on:click="openRuleDetail(rule, $event)" data-hide-by-side class="rule-severity">
                    <span class="icon-serious"
                          :data-status="rule.svrty === 4 ? 'critical' : rule.svrty === 3 ? 'high': rule.svrty === 2 ? 'medium': 'low'">{{ getSeverityLabel(rule) }}</span>
                </td>
                <!-- 수정 / 복사 / 삭제 버튼 -->
                <td v-on:click="openRuleDetail(rule, $event)"
                    v-if="isEditable && menuAuth === constants.AUTH_TYPE.EDIT" class="txt-c rule-option" data-hide-by-side>
                    <button type="button" class="buttons-icon" data-type="line"
                            data-size="s"
                            data-icon="edit"
                            :title="$t('COMMON.BUTTON.CAMEL.EDIT')"
                            data-trigger="popup-extension"
                            @click="callOpenPopup(rule, constants.FORM_TYPE.EDIT)">{{ $t('COMMON.BUTTON.CAMEL.EDIT') }}
                    </button>
                    <button type="button" class="buttons-icon" data-type="line"
                            data-size="s" data-icon="copy"
                            :title="$t('COMMON.BUTTON.CAMEL.COPY')"
                            data-trigger="popup-extension"
                            @click="callOpenPopup(rule, constants.FORM_TYPE.COPY)">{{ $t('COMMON.BUTTON.CAMEL.COPY') }}
                    </button>
                    <button type="button" class="buttons-icon" data-type="line"
                            data-size="s"
                            data-icon="delete"
                            :title="$t('COMMON.BUTTON.CAMEL.DELETE')"
                            data-trigger="delete-extension"
                            v-on:click="callDeleteRule([rule])">{{ $t('COMMON.BUTTON.CAMEL.DELETE') }}
                    </button>
                </td>
            </tr>
            <tr v-if="getRulesFilter.length === 0">
                <td colspan="5" class="data row">
                    <div class="none">
                        {{ $t('POLICY.RULE.NO_APPLIED_RULE') }}
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import _ from "lodash";
    import RuleProducts from "./ruleComponents/RuleProducts.vue";

    export default {
        name: "RuleList",
        components: {RuleProducts},
        props: {
            loadingRuleList: {
                type: Boolean,
                default: false
            },
            callImportRule: {
                type: Function,
                default: ()=>{}
            },
            policy: Object,                // Rule들이 속해있는 Policy 정보
            curRule: Object,               // Detail 정보에서 열려있는 Rule 정보
            categoryList: Array,           // 회사에 등록되어있는 Category Label 정보 리스트
            isReplica: Boolean,            // 사용자설정 Policy 확인 플래그
            callOpenPopup: Function,
            ruleList: Array,
            originalRuleList: Array,
            callDeleteRule: Function,
            callOpenRuleDetail: Function,
            callHideRuleDetail: Function,
            callSetSearchKey: Function,
            callSetSortColumn: Function,
            templateList: Array,
            menuAuth: String,
        },
        data() {
            return {
                checkList: [],
                searchSvrty: [],                     // SearchList of Severity : 처음 전체선택으로 모든 값 넣어줌
                sortColumn: '',                                // Sort column
                sortOrder: '',                                 // Sort order
                titlRender: 0,
                maxWidth: 300,
                listRulesFilter: []
            }
        },
        computed: {
            isEditable: function () {
                return !(this.policy.userDefiYn === 'N' && this.isReplica === false)
            },
            selectCheckAll: {
                get: function () {
                    let isAll = false;
                    const checkListCount = _.get(this.checkList, 'length');
                    if (this.ruleList) {
                        if (checkListCount > 0 && checkListCount === this.ruleList.length) {isAll = true;}
                    }
                    return isAll;
                },
                set: function (value) {
                    let selected = [];
                    if (value) {
                        this.ruleList.forEach(function (rule) {
                            selected.push(rule);
                        })
                    }
                    this.checkList = selected;
                }
            },
            ctgLabelFilterData() {
                self = this;
                let ctgFilter = [];
                if (this.originalRuleList && this.templateList) {
                    this.originalRuleList.forEach(function (r) {
                        for (let ctg of r.ctgLabel) {
                            let category = _.find(self.categoryList, {ctgId: ctg})
                            if (typeof (category) !== "undefined") {
                                ctgFilter.push({
                                    key: ctg,
                                    val: category.constructor === Object ? category.ctgLabel : ctg
                                })
                            }
                        }
                    })
                }
                return _.unionBy(ctgFilter, 'key');
            },
            prodFilterData() {
                let prodFilter = [];
                let haveManual = false;
                if (this.originalRuleList && this.templateList) {
                    this.originalRuleList.forEach((rule)=>{
                        if (rule.autoExeYn === "Y") {
                            const conditions = rule.cndVal;
                            conditions.forEach((cnd)=>{
                                const ruleProd = _.find(this.templateList, {'tmpltId': cnd.tmpltId});
                                if (ruleProd) {
                                    const val = this.$t('PRODUCT.' + ruleProd.prod);
                                    const vendor = this.Common.getVendorByKey(ruleProd.vendor);
                                    prodFilter.push({
                                        key: ruleProd.prod,
                                        val, vendor
                                    });
                                }
                            })
                        } else {
                            haveManual = true;
                        }
                    });
                }
                if (haveManual) {
                    const manualProduct = {
                        key: 'manual',
                        val: this.$t('LABEL.MANUAL_RULE')
                    }
                    prodFilter.push(manualProduct);
                }
                return _.unionBy(prodFilter, 'key');
            },
            getRulesFilter: function() {
                this.listRulesFilter = this.ruleList.filter((r) => {
                    let chkSvrtyFilter = _.isEmpty(this.searchSvrty) || (_.size(this.searchSvrty) === _.size(this.constants.SVRTY_FILTER)) 
                        || _.includes(this.searchSvrty, r.svrty);
                    return chkSvrtyFilter;
                });
                return this.listRulesFilter;
            },
        },
        created: function () {
            this.initMultiFilter();
        },
        mounted() {
            this.initMultiFilter();
            document.getElementsByClassName("selection dropdown multiple")[0].addEventListener("click", this.clickOnSlctCtg);
            document.getElementsByClassName("selection dropdown multiple")[1].addEventListener("click", this.clickOnSlctProd);
            window.addEventListener('resize', () => {
                this.maxWidth = 300;
                let _this = this;
                setTimeout(() =>{
                    let maxWidth = (_this.$refs.columnRuleName || {}).clientWidth;
                    _this.maxWidth = maxWidth;
                }, 100);
                ($('span[indexrule]') || []).each(function(value){
                    let innerWidth = $(this).width() + 5;
                    ($('div[indexrule=' + value +']') || []).attr('style', 'max-width : calc(100% - ' + innerWidth + 'px)');
                });
            });
            
        },
        methods: {
            clickOnSlctProd(e) {
                this.hideMenu("select_ctg");
                const firstChildNode = _.get(e, "target.firstChild.nodeName");
                if (firstChildNode !== "SELECT") return;
                const select = document.getElementsByClassName("select_prod multiple")[0];
                const target = select.getElementsByClassName("menu transition")[0];
                if (document.getElementsByClassName("menu visible")[0]) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");
                    select.classList.remove("active");
                } else if(document.getElementsByClassName("menu hidden")[0]) {
                    target.classList.remove("hidden");
                    target.classList.add("visible");
                }
            },
            clickOnSlctCtg(e) {
                this.hideMenu("select_prod");
                const firstChildNode = _.get(e, "target.firstChild.nodeName");
                if (firstChildNode !== "SELECT") return;
                const select = document.getElementsByClassName("select_ctg multiple")[0];
                const target = select.getElementsByClassName("menu transition")[0];
                if (document.getElementsByClassName("menu visible")[0]) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");

                    select.classList.remove("active");
                } else if(document.getElementsByClassName("menu hidden")[0]) {
                    target.classList.remove("hidden");
                    target.classList.add("visible");
                }
            },
            hideMenu(targetMenu) {
                const select = document.getElementsByClassName(`${targetMenu} multiple`)[0];
                const target = select.getElementsByClassName("menu transition")[0];
                if (target) {
                    target.classList.remove("visible");
                    target.classList.add("hidden");
                    select.classList.remove("active");
                }
            },
            getRuleTitle(rule) {
                let title = rule.titl;
                if (this.isReplica && rule.transTitl) {
                    title = rule.transTitl;
                } else if (rule.siteCd === this.constants.POLICY_TYPE.BEST_PRACTICE) {
                    const localeTitle = _.get(rule,`${this.$i18n.locale}RuleTitle`);
                    if (localeTitle) {
                        title = localeTitle;
                    }
                }
                return title;
            },
            // 기존에 등록된 Policy 목록 조회(Policy 목록에 Rule, Condition 도 함께 조회)
            // Folder Open
            openRuleDetail: function (rule, $event) {
                if ($event.target.nodeName !== 'BUTTON' && !this.isReplica) {
                    this.callOpenRuleDetail(rule);
                }
            },
            getCategoryLabel(ctgId) {
                var categoryLabel = ''
                for (var category of this.categoryList) {
                    if (category.ctgId === ctgId) {
                        categoryLabel = category.ctgLabel
                    }
                }
                return categoryLabel
            },
            getSeverityLabel(rule) {
                return this.$t("LABEL.SVRTY." + rule.svrty)
            },
            initMultiFilter: function () {
                let $filterTarget = $('.buttons-tbl-header[data-type=filter]')
                $filterTarget.tooltipster({
                    animation: 'fade',
                    side: 'bottom',
                    theme: 'go-filter',
                    interactive: true,
                    trigger: 'click',
                    functionBefore: function (instance, helper) {
                        $(helper.origin).addClass("selected");
                    },
                    functionAfter: function (instance, helper) {
                        $(helper.origin).removeClass("selected");
                    },
                    functionPosition: function (instance, helper, position) {
                        position.coord.top -= 7;
                        position.coord.left = helper.geo.origin.offset.right - position.size.width;
                        return position;
                    }
                });
            },
            clearSearchTxt() {
                this.$refs.searchTxt.value = '';
            },
            doneLoopArray(index) {
                if(index === (this.listRulesFilter.length - 1)){
                    let _this = this;
                    if (this.maxWidth === 300){
                        setTimeout(() =>{
                            let maxWidth = _this.$refs.columnRuleName.clientWidth;
                            if (maxWidth !== 0) {
                                _this.maxWidth = maxWidth;
                                ($('span[indexrule]') || []).each(function(value){
                                    let innerWidth = $(this).width() + 5;
                                    ($('div[indexrule=' + value +']') || []).attr('style', 'max-width : calc(100% - ' + innerWidth + 'px)');
                                });  
                            }
                        }, 100); 
                    }
                }
                return true;
            },
        },
    }
</script>

<style scoped>
.data.row {
    display: table-cell;
}
.product-name {
    display: flex;
    align-items: center;
}
.rule-select {
    width: 5%;
}
.rule-title {
    width: 50%;
    word-break: break-word;
}
.rule-product {
    width: 15%;
    word-break: break-word;
}
.rule-severity {
    width: 10%;
    word-break: break-word
}
.rule-option {
    width: 10%
}
</style>



// WEBPACK FOOTER //
// src/components/rule/RuleList.vue